import React from 'react';

interface ChartWrapperProps {
    title?: string;
    children: React.ReactNode;
    className?: string;
}

const ChartWrapper: React.FC<ChartWrapperProps> = ({ 
    title, 
    children, 
    className = "" 
}) => {
    return (
        <div className={`bg-white dark:bg-[#2D3748] rounded-lg shadow-lg p-4 h-full ${className}`}>
            {title && (
                <div className="mb-3">
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                        {title}
                    </h3>
                </div>
            )}
            <div className="h-full">
                {children}
            </div>
        </div>
    );
};

export default ChartWrapper; 